<template>
  <div class="forbidden">Forbidden!</div>
</template>

<script>
export default {
  name: "Forbidden",
};
</script>
